import { render } from "./App.vue.js?vue&type=template&id=9ea96fac!=!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=template&id=9ea96fac"
const script = {}

import "./App.vue.scss?vue&type=style&index=0&id=9ea96fac&lang=scss!=!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=style&index=0&id=9ea96fac&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__